import { LocalStorageService } from './../../core/services/local-storage.service';
import { Component, Input,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyService } from '@core/services/company/company.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { clientMenuItems, esnMenuItems } from './menu.items';

@Component({
  selector: 'app-sidebar-client',
  templateUrl: './sidebar-client.component.html',
  styleUrls: ['./sidebar-client.component.css'],
})
export class SidebarClientComponent implements OnInit{
  @Input() subscription: any;  // Receive the subscription input
  @Input() hasSubscription: boolean = false;  // Initialize the hasSubscription variable
  typeintervenant: string | null | number =
    this.localStorageService.getData('typeintervenant');
    private unsubscribeAll: Subject<void> = new Subject();
  connectedUser: string | null | number =

   this.localStorageService.getData('userConnected');

   menuItems:any;
   openMenus: Set<string> = new Set();
   connectedName: string | null | number =

   this.localStorageService.getData('clientConnectedName');
  currentUser: any;
  companyRoleId: any;
  idinter: any;
  entreprise:any;
  currentData:any
  AllPermissions:any
  isOpen = false;
  isMenuJobRequestOpen: boolean = false;
  isMenuJobOfferESNOpen: boolean = false;
  isMenuOurJobOffersOpen: boolean = false;
  isMenuOurConsultantsOpen: boolean = false;
  isMenuWegestUOpen: boolean = false;
  isMenuCRAOpen: boolean = false;
  isMenuEvaluationOpen: boolean = false;
  isMenuSettingsOpen: boolean = false;
  isMenuOurClientsOpen: boolean = false;
  selectedLink: string | null = null;
  openedMenus: Set<string> = new Set();
  newTitle : string ='';
  roleUser : any;
  constructor(private localStorageService: LocalStorageService,
    private router: Router, private companyService: CompanyService) {
  }
  userConnected(): boolean {
    return this.connectedUser !== null; // or any specific condition
  }

  typeIntervenant(): boolean {
    return this.typeintervenant === '2'; // or '3' for final client
  }

  isConditionMet(condition: string): boolean {
    // If no condition is provided, return true to display the item
    if (!condition) {
      return true;
    }
    if (condition.startsWith('!')) {
      const prop = condition.slice(1) as keyof this; // Remove '!' and assert it as a key of the component

      // Ensure the value accessed is a boolean and explicitly cast to boolean
      return typeof this[prop] === 'boolean' ? !(this[prop] as boolean) : false;
    }

    // Ensure the value accessed is a boolean and explicitly cast to boolean
    return typeof this[condition as keyof this] === 'boolean' ? (this[condition as keyof this] as boolean) : false;
  }

  private isOpenSubject = new BehaviorSubject<boolean>(
    JSON.parse(localStorage.getItem('accordionState') || 'false')
  );
  isOpen$ = this.isOpenSubject.asObservable();
  ngOnInit(): void {
    this.getcurrentUser();
    this.menuItems= this.connectedUser === '2' || ['2','4'].includes(this.typeintervenant as string) ? esnMenuItems : clientMenuItems;
    this.filterInterMenuItems(this.companyRoleId)
    this.idinter =  this.currentUser?.uuid;
    this.getuserById();
    if (this.subscription) {
      this.hasSubscription = true;
    } else {
      this.hasSubscription = false;
    }
  
    const elements = document.getElementsByClassName('has-item-children');
    Array.from(elements).forEach((el: Element) => {
      el.classList.remove('active');
    });
  }
  toggle() {
    const newState = !this.isOpenSubject.value;
    this.setOpenState(newState);
  }

  setOpenState(state: boolean) {
    this.isOpenSubject.next(state);
    localStorage.setItem('accordionState', JSON.stringify(state));
  }
  getcurrentUser() {
    this.currentUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}');
    this.companyRoleId = this.currentUser?.role_user_id;
  }
  isMenuItemOpen(): boolean {
    // Check if the current route matches any of the routes for the dropdown items
    return this.router.url.includes('liste-appels-offres') || this.router.url.includes('appels-offres') ||
           this.router.url.includes('liste-candidats');
  }
  selectLink(link: string) {
    this.selectedLink = link;
  }
  toggleMenuESN(menu: string) {
    if (this.openedMenus.has(menu)) {
      this.openedMenus.delete(menu);
    } else {
      this.openedMenus.add(menu);
    }
  }
  getMenuClassName(item:any) {
    // openedMenus.has('menu-' + item.title.replace(/\s+/g, '-'))
    return 'menu-' + item.title.replace(/\s+/g, '-');
  }
  getListPermissions(){
    this.companyService
        .getAllPermissionsByUser()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res:any) => {
            this.AllPermissions=res.data
          },
          error: () => {
          },
        });
  }
  hasPermission(permissionName: string): boolean {
    return this.AllPermissions?.some((perm: any) => perm.name === permissionName);
  }
  getuserById() {
      this.companyService
        .getUserByIdsidebare(this.idinter)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res:any) => {
            this.roleUser = res?.data?.role_user_id;
            this.currentData=res.data
            this.entreprise=res?.data?.company_name;
            
          },
          error: () => {

          },
        });
    }
    toggleMenu(item: any): void {
      if (this.openMenus.has(item.title)) {
        this.openMenus.delete(item.title);
      } else {
        this.openMenus.add(item.title);
      }
    }
    idDisplayed () {

    }
    getClass(item: any): any {
      return {
        'hide': item.title === 'Appel d’offre',
        'no-displayed':  (['Nos intervenants', 'Notre compte'].includes(item.title) && Array.isArray(this.roleUser) &&
        this.roleUser[0] != null && 
        this.roleUser[0] !== 'ESNAB' &&
        this.roleUser[0] !== 'ESNNAB') ,
        'has-item-children': item.children?.length>0,
        'disabled-link': this.isLinkDisabled(item)

      };
    }
    isMenuOpen(item: any): boolean {
      return this.openMenus.has(item.title);
    }
    isEsnNotSubscribed(): boolean {
      return this.currentData?.role_user_id.includes("8");
    }
    isEsnSubscribed(): boolean {
      return this.currentData?.role_user_id.includes("7");
    }

    subscribeToProfileUpdates() {
      this.companyService.profileUpdated.subscribe(() => {
        this.getuserById();
      });
    }
    toggleMenuJobRequest() {
      this.isMenuJobRequestOpen = !this.isMenuJobRequestOpen;
    }
    toggleMenuJobOfferESN() {
      this.isMenuJobOfferESNOpen = !this.isMenuJobOfferESNOpen;
    }
    toggleMenuOurJobOffers() {
      this.isMenuOurJobOffersOpen = !this.isMenuOurJobOffersOpen;
    }
    toggleMenuOurConsultants() {
      this.isMenuOurConsultantsOpen = !this.isMenuOurConsultantsOpen;
    }
    toggleMenuCRA() {
      this.isMenuCRAOpen = !this.isMenuCRAOpen;
    }
    toggleMenuEvaluation() {
      this.isMenuEvaluationOpen = !this.isMenuEvaluationOpen;
    }
    toggleMenuOurClients() {
      this.isMenuOurClientsOpen = !this.isMenuOurClientsOpen;
    }
    toggleMenuSettings() {
      this.isMenuSettingsOpen = !this.isMenuSettingsOpen;
    }
    toggleMenuWegestU() {
      this.isMenuWegestUOpen = !this.isMenuWegestUOpen;
    }

    canceledJobRequest(){
      Swal.fire({
        title: 'Fonctionnalité à venir prochainement. Merci pour votre compréhension',
        icon: 'warning',
        iconColor: '#63c3e8',
        confirmButtonColor: '#63c3e8',
        confirmButtonText: 'J’ai compris'
      })
    }
    isLinkDisabled(item: any): boolean {
      return (
       ( item.requiresSubscription &&  !this.hasSubscription)
        ||
        (this.hasSubscription && item.requiresFeature && !(this.subscription?.features?.some((feature: any) => feature.name === item.requiresFeature)))
      );
    }

    filterInterMenuItems(titlesToCheck: string[]) {
      if (titlesToCheck.includes('6')) {
        this.menuItems = this.menuItems.filter(
          (item: { title: string; }) => item.title !== "Nos intervenants" && item.title !== "Notre compte"
        );
      }
    }
  }

